/**
 * Copyright(c) 2024 Magrabi.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Magrabi ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Magrabi.
 *
 * @module Badges
 *
 * @author Anoop SS
 */

import { Product, TranslationData, VariantItemPdp } from "../common/lib/types";
import { getValueBasedOnLanguage, hasArrayElements } from "./commonUtils";

const badgeStyles = ["bg-light", "bg-secondary", "text-bg-dark"];

export const calculateProductBadges = (
  product: Product,
  language: string,
  selectedVariant: VariantItemPdp | undefined,
  translations?: TranslationData,
  transactional: boolean = true
): Product => {
  if (!product || !selectedVariant) return { ...product, selectedVariantBadges: [] };

  const visibleBadges = (selectedVariant?.badgeList && hasArrayElements(selectedVariant?.badgeList) ? selectedVariant?.badgeList?.slice(0, 2) : []).map(
    (badge, index) => ({
      name: getValueBasedOnLanguage(language, badge, "name", "name", badge?.translation),
      style: badgeStyles[index] || "",
    })
  );
  if (!selectedVariant?.quantityAvailable && transactional) {
    visibleBadges.unshift({ name: translations?.pdp?.pdp_out_of_stock_label || "Out of Stock", style: badgeStyles[2] });
  }

  return { ...product, selectedVariantBadges: visibleBadges };
};

export default calculateProductBadges;
